import { getFirestore, collection, addDoc, updateDoc, doc } from "firebase/firestore";
import * as firebase from 'firebase/app';

const realFormat = {
    minimumFractionDigits: 2,
    style: "currency",
    currency: "BRL",
};

const config = {
    apiKey: "AIzaSyCkj-iv0gpMxukbRgrBJROxqf_gUs9onts",
    authDomain: "simulador-gc.firebaseapp.com",
    projectId: "simulador-gc",
    storageBucket: "simulador-gc.appspot.com",
    messagingSenderId: "305725882897",
    appId: "1:305725882897:web:52a1c8d2581b133246e7b0",
    measurementId: "G-XZLZP62W4J"
}

const firebaseApp = firebase.initializeApp(config)
const db = getFirestore(firebaseApp);

const saveName = async (name) => {
    const docRef = await addDoc(collection(db, "simulacoes"), {
        name: name,
        date: new Date(),
        nParcelas: 0,
        valorCredito: 0,
        taxaAdm: 0,
        taxaReserva: 0,
        valorLance: 0,
        saldoDevedor: 0,
        valorEntrada: 0,
        valorParcelas: 0,
        nParcelasRestantes: 0,
    })
    return docRef
}

const saveValues = async (values,docID, adm) => {
    console.log('Saving values', values,docID)
    const docRef = doc(db, "simulacoes", docID)
    await updateDoc(docRef, {
        nParcelas: values.nPar,
        valorCredito: values.vCred.toLocaleString("pt-BR", realFormat),
        taxaAdm: values.tAdm,
        taxaReserva: values.tRes,
        valorLance: values.vLan.toLocaleString("pt-BR", realFormat),
        saldoDevedor: values.sDev.toLocaleString("pt-BR", realFormat),
        valorEntrada: values.vEnt.toLocaleString("pt-BR", realFormat),
        valorParcelas: values.vPar.toLocaleString("pt-BR", realFormat),
        nParcelasRestantes: values.nParRestantes,
        adm: adm
    })
    return true;
}

export {
    saveName,
    saveValues
}